import { BsFillSkipStartFill } from "react-icons/bs";
import { IoIosSave } from "react-icons/io";
import InputField from "../../common/InputField";
import Button from "../../common/Button";
import { notify } from "../../common/Toast";

export const ProductionCard = ({
  row,
  index,
  isModal = false,
  handleSave,
  handleActionChange,
  handleProdStart,
  handleRowChange,
  handleSaveBilletChange,
  calcFinal,
  safeDiv,
  isCastingData,
  dieUnloadReason,
  inProductionData,
  handleDieUnload,
  isSaving = false,
}) => (
  <div
    key={index}
    className="bg-white shadow-sm border border-slate-200 rounded-2xl overflow-hidden hover:shadow-md transition-shadow"
  >
    <div className="bg-slate-50 px-5 py-4 border-b border-slate-200 flex flex-wrap justify-between items-center gap-4">
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider">
            Order:
          </span>
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-white border font-bold text-sm text-primary shadow-sm">
            {row.order_No}
          </span>
          {row.order_Status && (
            <span className="bg-green-50 text-green-700 border border-green-100 px-3 py-1 rounded-md text-xs font-bold">
              {row.order_Status}
            </span>
          )}
        </div>

        <div className="flex flex-wrap gap-2">
          <span className="bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-md text-xs font-bold">
            Batch: {row.batch_Id}
          </span>
          <span className="bg-purple-50 text-purple-700 border border-purple-100 px-3 py-1 rounded-md text-xs font-bold">
            Profile: {row.profile_Name}
          </span>
          <span className="bg-slate-100 text-slate-700 border border-slate-200 px-3 py-1 rounded-md text-xs font-bold">
            Die: {row.dieNumber}
          </span>
          <span className="bg-orange-50 text-orange-700 border border-orange-100 px-3 py-1 rounded-md text-xs font-bold">
            Ord Pcs: {row.qty_Pcs}
          </span>
          <span className="bg-emerald-50 text-emerald-700 border border-emerald-100 px-3 py-1 rounded-md text-xs font-bold">
            Ord Wt: {row.qty_Weight}
          </span>
          <span className="bg-yellow-50 text-yellow-700 border border-yellow-100 px-3 py-1 rounded-md text-xs font-bold">
            Cut Length: {row.cut_Length}
          </span>
          <span className="bg-pink-50 text-pink-700 border border-pink-100 px-3 py-1 rounded-md text-xs font-bold">
            Current Wt: {row.current_Die_Weight}
          </span>
        </div>
      </div>

      <div className="flex gap-2">
        {isModal ||
        row.order_Status === "RUNNING" ||
        row.order_Status === "COMPLETED" ? (
          <>
            {!isModal && (
              <select
                className="bg-white text-slate-700 border border-slate-200 px-2 py-1 rounded-md text-xs font-bold outline-none focus:border-blue-300 shadow-sm cursor-pointer"
                onChange={(e) => handleActionChange(index, e.target.value)}
                value={row.selectedAction || ""}
              >
                <option value="">Select Action</option>
                <option
                  value="billet_change"
                  disabled={row.order_Status === "COMPLETED"}
                  className={`${row.order_Status === "COMPLETED" ? "text-slate-400" : ""}`}
                >
                  Billet Change
                </option>
                <option
                  value="die_unload"
                  disabled={row.order_Status === "COMPLETED"}
                  className={`${row.order_Status === "COMPLETED" ? "text-slate-400" : ""}`}
                >
                  Die Unload
                </option>
                <option value="mark_done">Mark Done</option>
              </select>
            )}

            <Button
              onClick={() => {
                if (isModal) {
                  return handleSaveBilletChange();
                }

                const act = inProductionData[index]?.selectedAction;
                const reason = inProductionData[index]?.die_Unload_Reason_Id;

                if (act === "die_unload") {
                  if (!reason) return notify("Unload reason required!", "error");

                  return handleDieUnload(inProductionData[index], index);
                } else {
                  handleSave(row, index);
                }
              }}
              className="p-2.5 text-green-600 hover:bg-green-50 rounded-xl border border-transparent hover:border-green-200 transition-all font-bold text-xs flex items-center gap-2"
              icon={IoIosSave}
              loading={isSaving}
              loadingText={isModal ? "Saving Billet Change..." : "Saving..."}
              text={isModal ? "Save Billet Change" : ""}
            />
          </>
        ) : (
          !isModal && (
            <Button
              className="p-2.5 flex text-blue-600 bg-blue-50 rounded-xl border border-blue-400 hover:border-green-200 transition-all font-bold text-xs items-center gap-2"
              onClick={() => handleProdStart(row, index)}
              icon={BsFillSkipStartFill}
              loading={isSaving}
              loadingText="Starting..."
              text="Prod. Start"
            />
          )
        )}
      </div>
    </div>
    <div className="p-5">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-6">
        <InputField
          label="Casting No"
          type="select"
          options={isCastingData}
          value={row.casting_No}
          onChange={(val) => handleRowChange(index, "casting_No", val)}
          required
        />

        <InputField
          label="Die In"
          type="time"
          value={row.die_In}
          onChange={(e) => handleRowChange(index, "die_In", e)}
        />

        <InputField
          label="Die Out"
          type="time"
          value={row.die_Out}
          onChange={(e) => handleRowChange(index, "die_Out", e)}
        />

        <InputField
          label="Pcs Needed"
          value={row.pcs_Needed}
          onChange={(e) => handleRowChange(index, "pcs_Needed", e)}
        />

        <div className="flex flex-col gap-1">
          <InputField
            label="Billet Size"
            value={row.billet_Size}
            onChange={(e) => handleRowChange(index, "billet_Size", e)}
            required
          />
          {(() => {
            const v = calcFinal(row);
            return (
              v !== null && (
                <div className="flex items-center gap-1.5 px-2 py-1 bg-indigo-50 text-indigo-700 rounded-md border border-indigo-100 w-fit">
                  <span className="text-[10px] uppercase font-bold">Size:</span>
                  <span className="text-xs font-black">{v.toFixed(2)}</span>
                </div>
              )
            );
          })()}
        </div>

        <div className="flex flex-col gap-1">
          <InputField
            label="No Of Billets"
            value={row.no_Of_Billet}
            onChange={(e) => handleRowChange(index, "no_Of_Billet", e)}
            required
          />
          {(() => {
            const ratio = safeDiv(row.qty_Pcs, row.pcs_Needed);
            return (
              ratio !== null && (
                <div className="flex items-center gap-1.5 px-2 py-1 bg-amber-50 text-amber-700 rounded-md border border-amber-100 w-fit">
                  <span className="text-[10px] uppercase font-bold">Pcs:</span>
                  <span className="text-xs font-black">{ratio.toFixed(2)}</span>
                </div>
              )
            );
          })()}
        </div>

        <InputField
          label="Input Wt"
          value={row.input_Weight}
          unit="Kg"
          disabled
        />

        <InputField
          label="No Of Pcs"
          value={row.no_Of_Pcs}
          onChange={(e) => handleRowChange(index, "no_Of_Pcs", e)}
        />

        <InputField
          label="Out Wt"
          value={row.output_Weight}
          onChange={(e) => handleRowChange(index, "output_Weight", e)}
        />

        <InputField label="Recov (%)" value={row.recovry} disabled />

        <InputField
          label="But End Rej."
          value={row.but_End_Rejection_Mm}
          onChange={(e) => handleRowChange(index, "but_End_Rejection_Mm", e)}
          unit="mm"
        />
        <InputField
          label="Stretching Rej."
          value={row.stertching_Rejection_Ft}
          onChange={(e) => handleRowChange(index, "stertching_Rejection_Ft", e)}
          unit="Ft"
        />
        <InputField
          label="Ext Spd"
          value={row.ext_Speed}
          onChange={(e) => handleRowChange(index, "ext_Speed", e)}
        />

        <InputField
          label="Billet Temp"
          value={row.billet_Temp}
          onChange={(e) => handleRowChange(index, "billet_Temp", e)}
        />

        <InputField
          type="textarea"
          label="Remarks"
          value={row.remark}
          onChange={(e) => handleRowChange(index, "remark", e)}
        />

        <InputField
          type="select"
          label="Unload Reason"
          placeholder="Select reason"
          required
          options={dieUnloadReason}
          value={row.die_Unload_Reason_Id || ""}
          onChange={(val) => {
            handleRowChange(index, "die_Unload_Reason_Id", val);
          }}
        />
      </div>
    </div>
  </div>
);
